import Tools from '@hanzi-package/tools';
const app = {
    namespaced: true,
    state: {
        is_haiguan_alert: 1,
        is_purchase_alert: 1
    },
    mutations: {
        SETHAIGUANALERT: (state, val) => {
            state.is_haiguan_alert = val;
        },
        SETPURCHASEALERT: (state, val) => {
            state.is_purchase_alert = val;
        },
    },
    actions: {
        setHaiguanAlert({ commit, val }) {
            commit('SETHAIGUANALERT', val);
        },
        setPurchaseAlert({ commit, val }) {
            commit('SETPURCHASEALERT', val);
        }
    }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js